const STATES = {
  STATE_REQUESTED: 'REQUESTED',
  STATE_CONFIRMED: 'CONFIRMED',
  STATE_CONFIRMED_APPROVED: 'CONFIRMED_APPROVED',
  STATE_UNDERWAY: 'UNDERWAY',
  STATE_COMPLETED: 'COMPLETED',
  STATE_COMPLETED_PAID: 'COMPLETED_PAID',
  STATE_COMPLETED_DELINQUENT: 'COMPLETED_DELINQUENT',
  STATE_CANCELLED: 'CANCELLED',
  STATE_DECLINED: 'DECLINED',
  STATE_VENDOR_NO_SHOW: 'VENDOR_NO_SHOW',
  STATE_NEEDS_RESCHEDULE: 'NEEDS_RESCHEDULE',

  // These are front-end only states. They do not exist in the backend enum
  STATE_TIMEDOUT: 'TIMEDOUT',
  STATE_READY_TO_CHARGE: 'READY_TO_CHARGE', // This is only used in a very specific case
}
const PAYMENT_STATES = {
  PAYMENT_STATE_PAID: 'PAID',
  PAYMENT_STATE_PROCESSING: 'PROCESSING',
  PAYMENT_STATE_DECLINED: 'DECLINED',
  PAYMENT_STATE_CANCELLED: 'CANCELLED',
  PAYMENT_STATE_REFUNDED: 'REFUNDED',
}
export default {
  TAB_NEEDS_APPROVAL: 0,
  TAB_UPCOMING_RESERVATION: 1,
  TAB_PAST_RESERVATION: 2,
  OPERATIONAL_RESERVATIONS_PAGE_TITLE: 'Operational Reservations',
  RECREATIONAL_RESERVATIONS_PAGE_TITLE: 'Recreational Reservations',
  ENTER_SEARCH_KEYWORDS_CONSTANT: 'Search by resident, unit number or amenity...',
  BTN_SAVE_CHECKIN: 'Save and check in',
  BTN_SAVE: 'Save',
  BTN_CANCEL: 'Cancel',
  BTN_ADD: 'Make a reservation',
  BTN_DISCARD_CHANGES: 'Discard changes',
  ...STATES,
  ...PAYMENT_STATES,
  RESERVATION_STATE_LABELS: {
    [STATES.STATE_REQUESTED]: 'Pending approval',
    [STATES.STATE_CONFIRMED]: 'Confirmed',
    [STATES.STATE_CONFIRMED_APPROVED]: 'Approved',
    [STATES.STATE_UNDERWAY]: 'Underway',
    [STATES.STATE_COMPLETED]: 'Completed',
    [STATES.STATE_COMPLETED_PAID]: 'Completed (Paid)',
    [STATES.STATE_COMPLETED_DELINQUENT]: 'Completed (Delinquent)',
    [STATES.STATE_CANCELLED]: 'Cancelled',
    [STATES.STATE_DECLINED]: 'Declined',
    [STATES.STATE_TIMEDOUT]: 'Timed Out',
    [STATES.STATE_VENDOR_NO_SHOW]: 'Vendor No Show',
    [STATES.STATE_NEEDS_RESCHEDULE]: 'Needs Reschedule',
    [STATES.STATE_READY_TO_CHARGE]: 'Ready to charge',
  },
  BTN_APPROVE_REQUEST: 'Approve request',
  BTN_SAVE_AND_APPROVE_REQUEST: 'Save and approve request',
  BTN_SAVE_AND_APPROVE: 'Save and approve',
  BTN_UPDATE_REQUEST: 'Update request',
  BTN_DENY_REQUEST: 'Deny request',
  BTN_CHAT_RESIDENT: 'Chat resident',
  BTN_VIEW_PROFILE: 'View profile',
  BTN_DELETE: 'Delete',
  RESERVATION_TIME_FORMAT: 'h:mma',
  RESERVATION_DATE_FORMAT: 'MMM DD, YYYY',
  RECREATIONAL_RESERVATION_CALENDAR: 'Recreational Reservation Calendar',
  OPERATIONAL_RESERVATION_CALENDAR: 'Elevators/Key Pick-Up',
  PAGE_TITLE_OPERATIONAL_AMENITY_MANAGER: 'Operational Amenities Manager',
  PAGE_TITLE_RECREATIONAL_AMENITY_MANAGER: 'Recreational Amenities Manager',
  BTN_ADD_AMENITY_MANAGER: 'Create new amenity',
  ACTIONS_MENU_EDIT_AMENITY: 'Edit amenity',
  ACTIONS_MENU_VIEW_RESERVATIONS: 'View reservations',
  ACTIONS_MENU_BOOK_FOR_TENANT: 'Book for tenant',
  NO_AMENITY_MESSAGE: 'There are currently no amenity. Select "Create new amenity" to create a new amenity.',

  ALL_FIELDS_REQUIRED: '* All starred fields are required.',

  TITLE_RESTRICTIONS: 'Restrictions',
  TITLE_CLOSURES: 'Block off amenity bookings',
  DESCRIPTION_CLOSURES: '* This copy shows up in the Resident App',
  TITLE_RULES: 'Rules for amenity',
  TITLE_PAID_RESERVATION: 'Paid reservation',
  TITLE_LINKED_AMENITIES: 'Amenity linking',
  TITLE_DETAILS: 'Details',

  NEEDS_APPROVAL_OPTIONS: [
    {value: 'false', label: "Doesn't need approval"},
    {value: 'true', label: 'Needs approval'},
  ],

  MINIMUM_RESERVATION_OPTIONS: [
    {value: '15', label: '15 minutes'},
    {value: '30', label: '30 minutes'},
    {value: '60', label: '1 hour'},
    {value: '120', label: '2 hours'},
    {value: '180', label: '3 hours'},
  ],
  daysInAWeek: [...new Array(7)].map((e, i) => i), // just an array from 0 -> 6
}
